// extracted by mini-css-extract-plugin
module.exports = {"image":"LandingWizardSeo_image__3F78I","uploadFaviconContainer":"LandingWizardSeo_uploadFaviconContainer__2vfEw"};